import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import moment from "moment";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { toast } from "react-toastify";

const CompanyFinancialMonth = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Company Financial Years"));
  }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [financialData, setFinancialData] = useState([]);
  const [financialDataModel, setFinancialDataModel] = useState(false);
  const [financialMonthData, setFinancialMonthData] = useState([]);
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({
    FYFromDate: false,
  });
  console.log("fieldErrors", fieldErrors);

  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    FYFromDate: null,
    FYToDate: null,
  });
  const resetForm = () => {
    setFormData({
      FYFromDate: null,
      FYToDate: null,
    });
    setError("");
    setFieldErrors({
      FYFromDate: false,
    });
  };
  const columns = {
    text: { text: "Year", align: "center", visible: true },
    FYFromDate: { text: "FY From Date", align: "center", visible: true },
    FYToDate: { text: "FY To Date", align: "center", visible: true },
  };

  useEffect(() => {
    fetchNewJoineers();
  }, []);

  const fetchNewJoineers = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}company-financial-month`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const financialMonths = response?.data?.financialyear;
        const data = financialMonths.reverse();
        setFinancialMonthData(data);
      } else {
        console.error(
          "Failed to fetch Upcoming Financial Month. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Financial Month:", error);
    }
  };

  const handleAdd = () => {
    resetForm();
    setFinancialDataModel(true);
    setError(""); // Reset error when opening modal
  };

  const checkFinancialYearExists = (date) => {
    if (!date || !financialMonthData.length) return false;

    // Format the date to match your financialMonthData format (adjust as needed)
    const selectedDate = moment(date).format("YYYY-MM-DD");

    // Check if any financial year in financialMonthData matches the selected date
    return financialMonthData.some(
      (fy) => moment(fy.FYFromDate).format("YYYY-MM-DD") === selectedDate
    );
  };

  const handleChange = useCallback(
    (e) => {
      let name, value;

      if (e && e.target) {
        name = e.target.name;
        value = e.target.value;
      } else {
        name = e.name;
        value = e.value;
      }

      setFormData((prevData) => {
        const newData = { ...prevData, [name]: value };

        if (name === "FYFromDate" && value) {
          try {
            const selectedDate = new Date(value);

            // Check if date is valid
            if (isNaN(selectedDate.getTime())) {
              toast.error("Please select a valid date");
              return { ...prevData, FYFromDate: null };
            }

            const day = selectedDate.getDate();
            const month = selectedDate.getMonth() + 1; // January = 1, December = 12

            // Validate that date is April 1st
            if (day !== 1 || month !== 4) {
              toast.error("Financial year must start on April 1st (1-Apr)");
              return { ...prevData, FYFromDate: null };
            }

            // Check if financial year already exists
            if (checkFinancialYearExists(value)) {
              setError("This financial year already exists");
              return { ...prevData };
            } else {
              setError("");
            }

            // Calculate FY To Date (March 31 of next year)
            const year = selectedDate.getFullYear();
            const nextYear = year + 1;
            const fyToDate = new Date(Date.UTC(nextYear, 2, 31)); // March = 2 (0-indexed)

            const formattedFYToDate = `${fyToDate.getUTCFullYear()}-${(
              fyToDate.getUTCMonth() + 1
            )
              .toString()
              .padStart(2, "0")}-${fyToDate
              .getUTCDate()
              .toString()
              .padStart(2, "0")}`;

            newData.FYToDate = formattedFYToDate;
          } catch (error) {
            console.error("Error processing date:", error);
            toast.error("Error processing date selection");
            return { ...prevData, FYFromDate: null };
          }
        }

        return newData;
      });
    },
    [financialMonthData]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset all errors first
    setFieldErrors({
      FYFromDate: false,
    });

    // Validate required fields
    let hasError = false;
    const newFieldErrors = { ...fieldErrors };

    if (!formData.FYFromDate) {
      newFieldErrors.FYFromDate = true;
      hasError = true;
      toast.error("FY From Date is required");
    }

    setFieldErrors(newFieldErrors);

    if (hasError) {
      return;
    }

    // Additional validations
    if (error || !formData.FYToDate) {
      return;
    }

    try {
      const payload = {
        fromDate: moment(formData.FYFromDate).format("DD-MM-YYYY"),
        toDate: moment(formData.FYToDate).format("DD-MM-YYYY"),
      };

      const response = await PostFormServiceCaller(
        `${API_URL}company-financial-month`,
        payload
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Financial year added successfully!");
        setFinancialDataModel(false);
        resetForm();
        fetchNewJoineers();
      } else {
        toast.error(
          `Failed to add financial year: ${
            response.data?.message || "Unknown error"
          }`
        );
      }
    } catch (error) {
      console.error("Error submitting financial year:", error);
      toast.error(`Error: ${error.response?.data?.message || error.message}`);
    } finally {
      setSubmitting(false);
    }
  };
  const isApril = new Date().getMonth() === 3;  
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={financialMonthData}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isAddNewBtnRequired={true}
              handleAddNew={handleAdd}
            />
          </div>
        </div>
        {financialDataModel && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1050,
            }}
          >
            <div
              className="modal-dialog modal-md modal-dialog-centered"
              role="document"
            >
              <div className="modal-content">
                <div
                  className="modal-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #f0f0f0",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <p
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      color: "#27568B",
                      margin: "0",
                    }}
                  >
                    Financial Month
                  </p>
                  <span className="me-2">
                    <i
                      className="bi bi-x-lg"
                      onClick={() => setFinancialDataModel(false)}
                    ></i>
                  </span>
                </div>
                <div className="modal-body p-2">
                  {isApril ? (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <div class="mb-3">
                            <label for="Name" class="form-label">
                              FY From Date
                            </label>
                            <CustomDatePicker
                              handleChange={handleChange}
                              value={formData.FYFromDate}
                              name="FYFromDate"
                              id="FYFromDate"
                              className={`form-control ${
                                fieldErrors.FYFromDate ? "is-invalid" : ""
                              }`}
                              placeholderText="FY From Date"
                            />
                            {fieldErrors.FYFromDate && (
                              <div
                                className="invalid-feedback"
                                style={{ display: "block" }}
                              >
                                FY From Date is required
                              </div>
                            )}
                            {error && (
                              <div className="text-danger small mt-1">
                                {error}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div class="mb-3">
                            <label for="MobileNo1" class="form-label">
                              FY To Date
                            </label>
                            <CustomDatePicker
                              handleChange={handleChange}
                              value={formData.FYToDate}
                              name="FYToDate"
                              id="FYToDate"
                              className="form-control"
                              placeholderText="FY To Date"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>

                      <div className="text-end">
                        <button
                          className="cancel-btn me-2"
                          onClick={() => setFinancialDataModel(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="custom-btn"
                          disabled={
                            error || !formData.FYFromDate || !formData.FYToDate
                          }
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  ) : (
                    <div className="p-4">
                      <h5 className="text-center">
                        Financial year can only be added in the month of April
                      </h5>
                      <div className="text-end">
                      <button
                        className="cancel-btn mt-3"
                        onClick={() => setFinancialDataModel(false)}
                      >
                        Close
                      </button>
                    </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CompanyFinancialMonth;
